/* istanbul ignore file */
import React from 'react';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleLeadBreadcrumbs from 'domain/sales/lead/shared/SingleLeadBreadcrumbs';

const ConvertLeadBreadcrumbs = () => {
  return (
    <SingleLeadBreadcrumbs>
      <BreadcrumbItem>Convert</BreadcrumbItem>
    </SingleLeadBreadcrumbs>
  );
};

export default ConvertLeadBreadcrumbs;
